import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { visuallyHidden } from "@mui/utils";
import { Button } from "../../Inputs/Button/index.js";
import { LinkButtonContainer, StyledChevronDown } from "./styles.js";
const COMPONENT_NAME = "PopoverButton";
const PopoverButton = forwardRef(
  ({
    buttonText,
    buttonAriaLabel,
    children,
    isOpen,
    href,
    onClick,
    onKeyDown,
    onMouseEnter,
    onMouseLeave,
    onMouseOver,
    openedOnHover,
    sx,
    variant,
    target
  }, ref) => {
    const ariaLabelForBtn = buttonAriaLabel ? buttonAriaLabel : typeof buttonText === "string" ? buttonText : "";
    if (href) {
      return /* @__PURE__ */ jsxs(LinkButtonContainer, { ref, sx, children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            href,
            "aria-label": ariaLabelForBtn,
            onMouseEnter,
            onMouseLeave,
            onMouseOver,
            variant,
            target,
            children: buttonText
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            "aria-label": ariaLabelForBtn,
            "aria-expanded": isOpen,
            variant: "text-button",
            onClick,
            onKeyDown,
            sx: isOpen && openedOnHover === false ? {} : {
              ":not(:focus-within)": {
                svg: {
                  ...visuallyHidden
                }
              }
            },
            children: /* @__PURE__ */ jsx(StyledChevronDown, {})
          }
        )
      ] });
    } else {
      return /* @__PURE__ */ jsxs(
        Button,
        {
          ref,
          "aria-label": ariaLabelForBtn,
          "aria-expanded": isOpen,
          onClick,
          onMouseEnter,
          onMouseLeave,
          onKeyDown,
          onMouseOver,
          sx,
          variant,
          children: [
            buttonText,
            children
          ]
        }
      );
    }
  }
);
PopoverButton.displayName = COMPONENT_NAME;
export {
  PopoverButton
};
